export function isNull(data: any) {
  return data === null
}

export function isUndefined(data: any) {
  return typeof data === 'undefined'
}

export function isNaN(data: any) {
  return Number.isNaN(data)
}

export function isValidData(data: any) {
  return !(isNull(data) || isUndefined(data) || isNaN(data))
}
